// extracted by mini-css-extract-plugin
module.exports = {"tab-item":"style_tab-item__Y61Tg","tab-item-count":"style_tab-item-count__t3rpb","tab-item-count-number":"style_tab-item-count-number__olBdS"};